<div class="d-flex container-fluid p-0 apiContainer" id="wrapper">
  <!-- Sidebar-->
  <div class="border-end bg-white" id="sidebar-wrapper">
    <span onclick="openNav()" class="openbtnIAG"><i class="fa fa-bars fa-lg"></i></span>
    <div class="list-group list-group-flush">
      <div id="mySidenav" class="sidenav">
        <div class="nav-header">
          <a href="javascript:void(0)" class="closebtnIAG" onclick="closeNav()">
            <i class="fa fa-bars fa-lg"></i>
          </a>
        </div>
        <div id="sideMenu-header" class="sideMenu-header">
          <a href="/home">
            <img class="sideMenu-logo logo3" [src]="configService.getLogo('BA_LOGO_MOBILE')" />
          </a>
        </div>
        <div class="sidebar-nav">
          <ul class="parent">
            <span class="notSubmenu">
              <a href="/" class="liclass">
                <span class="nav-text"><i class="fa fa-home fa-smx"></i>NDC Hub</span>
              </a>
            </span>

            <li *ngFor="let category of categories" [ngClass]="category?.subMenuIconClass ? 'submenu' : ''">
              <a class="liclass" (click)="category.url && setPageURL(category.url); setPageTitle(category.pageTitle || ''); closeNav()">
                <span class="nav-text"> <i [ngClass]="category.class ? category.class : ''"></i>{{ category.title }}</span>
              </a>

              <ul class="parent">
                <li *ngFor="let link of linkMap.get(category.title)" [ngClass]="link?.subMenuIconClass ? 'submenu' : ''">
                  <a class="liclass" (click)="link.url && setPageURL(link.url); setPageTitle(link.pageTitle || ''); closeNav()">
                    <span class="nav-text"> <i [ngClass]="link.class"></i>{{ link.title }}</span>
                  </a>

                  <ul class="parent">
                    <li *ngFor="let reference of link.references" [ngClass]="reference?.subMenuIconClass ? 'submenu' : ''">
                      <a
                        class="liclass"
                        [href]="reference.href"
                        (click)="
                          reference.url && setPageURL(reference.url); reference.pageTitle && setPageTitle(reference.pageTitle || ''); reference.href && scrollToClass(reference.href || ''); closeNav()
                        "
                      >
                        <span class="nav-text"> <i [ngClass]="reference.class"></i>{{ reference.title }}</span>
                      </a>

                      <ul class="parent">
                        <li *ngFor="let subReference of reference.subReferences" [ngClass]="subReference?.subMenuIconClass ? 'submenu' : ''">
                          <a
                            class="liclass"
                            href="#{{ subReference.href }}"
                            (click)="subReference.url && setPageURL(subReference.url); setPageTitle(subReference.pageTitle || ''); scrollToHref(subReference.href || ''); closeNav()"
                          >
                            <span class="nav-text"> <i [ngClass]="subReference.class"></i>{{ subReference.title }}</span>
                          </a>

                          <ul class="parent">
                            <li *ngFor="let _subReference of subReference.subReferences">
                              <a class="liclass" href="#{{ _subReference.href }}" (click)="scrollToHref(_subReference.href || ''); closeNav()">
                                <span class="nav-text"> <i [ngClass]="_subReference.class"></i>{{ _subReference.title }}</span>
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="apiContainerRight">
    <app-known-issues-content [pageTitle]="pageTitle" [href]="href" [subscribeUrl]="subscribeUrl"></app-known-issues-content>
  </div>
</div>
